import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/notification-message.svg")